<template>
  <div>
    <!-- <v-row class="row-menu-right mb-3 pl-3 pr-3">
      <v-btn
        rounded
        color="success"
        dark
        class="mr-2"
        @click="gotocreate('เครือ')"
      >
      <v-icon left dark color="white">fa-plus-circle</v-icon>
      เพิ่มสิทธิ์
      </v-btn>
    </v-row> -->
    <OverlayLoading :loading="loading" />
    <div>
      <v-data-table
        :headers="headers"
        :items="roleCompanyData"
        class="border-table-employee text-no-wrap mt-1"
        item-key="_id"
        :expanded.sync="expanded"
        loading-text="Loading... Please wait"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100, -1],
          'items-per-page': 15
        }"
        :server-items-length="total || -1"
        @update:items-per-page="changePerPage"
        @update:page="changePage"
        :page.sync="page"
        :items-per-page="perPage"
        hide-default-footer
        @page-count="pageCount = $event"
      >
      <template v-slot:[`item.no`]="{ item }">
          {{ (perPage*(page-1)) + roleCompanyData.indexOf(item)+1 }}
      </template>
      <template v-slot:[`item.companyImage`]="{ item }">
          <td style="width: fit-content !important;" class="py-2">
            <v-avatar
              size="50"
              rounded
            >
              <v-img
                contain
                :lazy-src="require('@/assets/icons/company-logo3.png')"
                :src="item.failed_image ? require('@/assets/icons/company-logo3.png') : item.companyImage"
                :alt="item.employeeId"
                v-on:error="onImgError(item.no-1)"
                aspect-ratio="2.7"
              />
            </v-avatar>
          </td>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            :color="item.status == 'approved' || item.status == 'acknowledge' ? '#ECF8EA' : item.status == 'reject' || item.status == 'denied' ? '#FBE5E4' : item.status == 'pending' ? '#FEF5E9' : item.status == 'cancel' ? '#F5F5F5':'#ECF9FF'"
            :text-color="item.status == 'approved' || item.status == 'acknowledge' ? '#58A144' : item.status == 'reject' || item.status == 'denied' ? '#D1392B' : item.status == 'pending' ? '#E9A016' : item.status == 'cancel' ? '#757575':'#ECF9FF'"
          >
            <span>{{ item.status == 'approved' || item.status == 'acknowledge' ? 'อนุมัติ' : item.status == 'reject' || item.status == 'denied' ? 'ไม่อนุมัติ' : item.status == 'pending' ? 'รออนุมัติ' : item.status == 'cancel' ? 'ยกเลิก':'-'}}</span>
          </v-chip>
        </template>
        <template v-slot:[`item.type`]="{ item }">
          <v-chip
          outlined
          :color="item.type == 'create' ? '#3776E9' : item.type == 'edit' ? '#E9A016': item.type == 'delete' ? '#D1392B':'#ECF9FF'"
          :text-color="item.type == 'create' ? '#3776E9' : item.type == 'edit' ? '#E9A016': item.type == 'delete' ? '#D1392B': '#ECF9FF'"
          >
          <span>{{ item.type == 'create' ? 'สร้างธุรกิจ' : item.type == 'edit' ? 'แก้ไขธุรกิจ' : item.type == 'delete' ? 'ลบธุรกิจ': '-' }}</span>
        </v-chip>
        </template>
        <template v-slot:[`item.data-table-expand`]="{ item }">
          <v-row class="d-flex px-4">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  rounded
                  dark
                  icon
                  class="mt-3 mb-3 ml-4"
                  @click="gotoPreview(item)"
                >
                <v-icon class="ml-auto icon-eye-color">mdi-eye-outline</v-icon>
                </v-btn>
              </template>
              <span class="label-table-action">ดูรายละเอียดธุรกิจ</span>
            </v-tooltip>
           <!-- <v-menu
              left
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  class="mt-3 mb-3 ml-2"
                >
                  <v-icon color="#DADADA">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list class="pa-0" style="border-radius: 4px;">
                <v-list-item @click="gotoEdit(item)" class="pl-5 pr-5">
                  <v-icon color="#DADADA">mdi-pencil-outline</v-icon>
                  <v-list-item-title class="pl-2">แก้ไขธุรกิจ</v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item @click="checkActionType(item)" class="pl-5 pr-5">
                  <v-icon color="#DADADA">mdi-delete-outline</v-icon>
                  <v-list-item-title class="pl-2">ลบธุรกิจ</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu> -->
          </v-row>
        </template>
      </v-data-table>
      <v-row>
      <v-col cols="12" class="pa-0">
      <div class="justify-end d-flex align-end pt-4">
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
        ></v-pagination>
      </div>
      </v-col>
    </v-row>
    </div>
    <v-dialog v-model="dialogConfirm" max-width="500px">
      <v-card height="170px">
        <v-card-title class="icon-eye-color ra-head-text-bold justify-center pa-5">ต้องการลบข้อมูลนี้ ใช่หรือไม่?</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลนี้</span>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="button-color-outline" outlined @click="dialogConfirm = false">ยกเลิก</v-btn>
          <v-btn class="button-color" dark @click="delRoleGroup()">ยืนยัน</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogApproverCompany"
        persistent
        max-width="420"
        max-height="232">
        <v-card tile class="justify-center">
          <v-card-title class="icon-eye-color ra-head-text-bold justify-center pa-5">ต้องการยกเลิกเอกสารนี้ใช่หรือไม่</v-card-title>
          <v-card-text class="justify-center text-center">
          <span class="ra-head-text justify-center">คุณแน่ใจหรือไม่ว่าต้องการยกเลิกเอกสารนี้</span>
          <!-- <span v-else-if="titleDialog === 'temporaryer'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span> -->
          <v-textarea v-model="comment" class="ml-8 mr-8" outlined rows="2" placeholder="ระบุความเห็น" @keydown.space="preventLeadingSpace"></v-textarea>
          </v-card-text>
          <v-card-actions class="">
            <v-spacer></v-spacer>
            <v-btn class="button-color-outline" outlined @click="dialogApproverCompany = false, comment = ''">ยกเลิก</v-btn>
            <v-btn v-if="comment === ''" class="ra-button1" color="grey" depressed disabled>ยืนยัน</v-btn>
            <v-btn v-else class="button-color" dark @click="updateStatusApprove('ยกเลิก')">ยืนยัน</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <v-dialog v-model="dialogConfirmDel" max-width="500px">
      <v-card height="180px">
        <v-card-title class="icon-eye-color ra-head-text-bold justify-center pa-5">ต้องการลบข้อมูลนี้ใช่ไหม</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center">คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูล</span>
        <!-- <span v-else-if="titleDialog === 'temporaryer'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span> -->
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="button-color-outline" outlined @click="dialogConfirmDel = false">ยกเลิก</v-btn>
          <v-btn class="button-color" dark @click="deleteBusiness()">ยืนยัน</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-row>
        <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          text
          top
          app
        >
        <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
        <span :style="{ 'color': `${snackbarColor}` }">{{ text }}</span>
        </v-snackbar>
      </v-row>
    </div>
  </div>
</template>

<script>
import {
  // getSelectBusiness,
  // fetchAllRequestManageBusiness,
  fetchAllRequestManageApproveBusiness,
  deleteGroupRole,
  deleteBusinessById
} from '@/API/API'
// import { OverlayLoading } from '@/components/index'
import OverlayLoading from '../../_template/OverlayLoading.vue'

import { EventBus } from '@/EventBus'
import swal from 'sweetalert'
const moment = require('moment')
const axios = require('axios')

export default {
  components: {
    OverlayLoading
  },
  data () {
    return {
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      dialogConfirm: false,
      dialogApproverCompany: false,
      dialogConfirmDel: false,
      approveType: '',
      comment: '',
      delConfirmId: '',
      expanded: [],
      filter: '',
      keywordShortName: '',
      keywordCompanyName: [],
      keywordGroupCompanyName: [],
      loading: true,
      perPage: 15,
      page: 1,
      pageCount: 0,
      total: -1,
      canSave: false,
      statusList: [
        { statusTH: 'กำลังดำเนินการ', color: '#00B0FF', colorback: '#ECF9FF' },
        { statusTH: 'รออนุมัติ', color: '#E9A016', colorback: '#FEF5E9' },
        { statusTH: 'อนุมัติแล้ว', color: '#58A144', colorback: '#ECF8EA' },
        { statusTH: 'ไม่อนุมัติ', color: '#D1392B', colorback: '#FBE5E4' }
      ],
      headers: [
        {
          text: 'ลำดับ',
          align: 'center',
          value: 'no',
          width: '65',
          sortable: false
        },
        { text: 'หมายเลขคำร้อง', value: 'requestNo', sortable: false },
        { text: 'รูปภาพ', value: 'companyImage', sortable: false, width: '70' },
        { text: 'ชื่อเต็มธุรกิจ', value: 'companyFullNameTh', sortable: false, width: '15%' },
        { text: 'รูปแบบธุรกิจ', value: 'businessModelType', sortable: false },
        // { text: 'ประเภทธุรกิจ', value: 'businessType', sortable: false },
        { text: 'ประเภทการลงทะเบียน', value: 'registerType', sortable: false },
        { text: 'วันที่สร้าง', value: 'createAt', sortable: true },
        { text: 'วันที่แก้ไขล่าสุด', value: 'updateAt', sortable: true },
        { text: 'สถานะ', value: 'status', sortable: false, align: 'center' },
        { text: 'สถานะคำร้อง', value: 'type', sortable: false, align: 'center' }, // สถานะคำร้องใหม่
        // { text: 'คะแนนความน่าเชื่อถือ', value: 'reliability' },
        { text: 'จัดการ', value: 'data-table-expand', sortable: false, width: '120px', align: 'center fixed', class: 'column-fix' }
      ],
      mockup: [],
      selectData: [],
      roleCompanyData: [],
      approveRole: localStorage.approveRole
    }
  },
  async created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    try {
      await this.initData()
    } catch (error) {
    } finally {
      // this.loading = false
    }
  },
  mounted () {
    EventBus.$on('manageCompanySearch', this.getSelect)
  },
  beforeDestroy () {
    EventBus.$off('manageCompanySearch')
  },
  methods: {
    // ป้องกันการกรอก Spacebar
    preventLeadingSpace (e) {
      // ป้องกันการกด spacebar ถ้ายังไม่มีการกรอกข้อมูล
      if (!e.target.value) e.preventDefault()
      // ถ้าหากอักขระนำหน้าเป็นช่องว่าง ให้ลบช่องว่างนำหน้าทั้งหมดออก
      else if (e.target.value[0] === ' ') e.target.value = e.target.value.replace(/^\s*/, '')
    },
    onImgError (i) {
      this.roleCompanyData[i].failed_image = true
    },
    changePerPage (value) {
      this.perPage = value
      this.initDataTable()
    },
    changePage (value) {
      this.page = value
      this.initDataTable()
    },
    async getSelect (data) {
      this.filter = data
      this.keywordCompanyName = data.companyName
      this.keywordGroupCompanyName = data.groupCompany
      this.total = -1
      this.perPage = 15
      this.page = 1
      await this.initData()
    },
    initData () {
      // this.initSelectData()
      this.initDataTable()
    },
    // ปิดไว่ก่อน
    // async initSelectData () {
    //   this.loading = true
    //   this.selectData = []
    //   const token = this.tokenUser
    //   const obj = {
    //     businessModelTap: 'company',
    //     businessType: '',
    //     _id: '',
    //     role: this.filter.role || this.approveRole,
    //     createAt: '',
    //     updateAt: ''
    //   }
    //   try {
    //     const res = await getSelectBusiness(obj, token)
    //     if (res.success) {
    //       // if (res.compermission.length) {
    //       this.selectData = res
    //       EventBus.$emit('getFilterฺBusinessCompany', this.selectData)
    //       EventBus.$emit('selectGroup', res)
    //       // }
    //       // console.log(res)
    //     } else {
    //       // console.log(res)
    //     }
    //   } catch (error) {
    //     // alert(error)
    //     console.log(error)
    //   } finally {
    //     this.loading = false
    //   }
    // },
    async initDataTable () {
      this.loading = true
      this.roleCompanyData = []
      const self = this
      const temp = []
      var statusType = ''
      if (this.filter.status === undefined) {
        statusType = ''
      } else {
        statusType = this.filter.status[0]
      }
      var obj = {
        businessModelTap: this.filter.businessModelTap,
        // reqBusinessNo: this.filter.reqCompanyNo || '',
        name: '', // ชื่อธุรกิจ
        businessModelType: '', // ประเภทธุรกิจ
        businessType: this.filter.businessType || [],
        // _id: this.filter.searchNameAndEmpId || [],
        type: '', // tab เปลี่ยนแปลงให้ส่งค่าว่างไป
        companyId: this.filter.searchNameAndEmpId || '',
        role: this.filter.role || this.approveRole,
        registerType: this.filter.registerType || '',
        status: statusType || '', // สเตตัส 'waiting', 'pending', 'approve', 'denied'
        createAt: this.filter.createAt || '',
        updateAt: this.filter.updateAt || '',
        limit: this.perPage,
        page: this.page
      }
      const token = this.tokenUser

      try {
        // const res = await fetchAllRequestManageBusiness(obj, token)
        const res = await fetchAllRequestManageApproveBusiness(obj, token) // เส้นใหม่
        if (res.success) {
          res.result.map((el, index) => {
            if (el.companyImage !== '') {
              el.companyImage = `${this.api}/api/vMonk/companys/getcompanyFileById/` + el.companyImage
            }
            // el.businessModelType = el.businessModelType === 'market' ? 'ธุรกิจร้านค้า' : 'นิติบุคคล'
            if (el.businessModelType === 'market') {
              el.businessModelType = 'ธุรกิจร้านค้า'
            } else if (el.businessModelType === 'corporation') {
              el.businessModelType = 'นิติบุคคล'
            } else {
              el.businessModelType = 'องค์กร'
            }
            if (el.registerType === 'registerFull') {
              el.registerType = 'ลงทะเบียนธุรกิจฉบับเต็ม'
            } else {
              el.registerType = 'ลงทะเบียนธุรกิจฉบับย่อ'
            }
            temp.push({
              no: index + 1,
              failed_image: false,
              ...el
            })
          })
          this.total = res?.count || -1
          this.roleCompanyData = temp
          self.computeData(self.roleCompanyData)
        } else {
          // console.log(res)
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async computeData (item) {
      await item.map(e => {
        e.createAt = moment(e.createAt).format('DD/MM/YYYY HH:mm น.')
        e.updateAt = moment(e.updateAt).format('DD/MM/YYYY HH:mm น.')
      })
    },
    manageLineWork (data) {
      // console.log('manage line work', data)
    },
    checkDelRoleGroup (id) {
      this.delConfirmId = ''
      this.delConfirmId = id
      this.dialogConfirm = true
    },
    async delRoleGroup (value) {
      this.loading = true
      const obj = {
        businessId: this.delConfirmId
      }
      try {
        const res = await deleteGroupRole(obj, this.tokenUser)
        if (res.success) {
          swal('สำเร็จ', 'ลบข้อมูลสำเร็จ', 'success', {
            button: false,
            timer: 2000
          }).then()
          this.initData()
          this.dialogConfirm = false
          this.delConfirmId = ''
        } else {
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
          this.dialogConfirm = false
          this.delConfirmId = ''
        }
      } catch (error) {
        console.log(error)
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
        this.dialogConfirm = false
        this.delConfirmId = ''
      } finally {
        this.loading = false
      }
    },
    async deleteBusiness () {
      const obj = {
        businessId: this.reqBusinessId
      }
      try {
        const res = await deleteBusinessById(obj, this.$store.state.token)
        if (res.success) {
          // swal('สำเร็จ', 'คุณได้ทำการลบข้อมูล เรียบร้อยแล้ว', 'success', {
          //   button: false,
          //   timer: 2000
          // })
          this.text = 'คุณได้ทำการลบธุรกิจเรียบร้อยแล้ว'
          this.snackbarColor = 'success'
          this.snackbar = true
          this.dialogConfirmDel = false
          this.initData()
          await EventBus.$emit('countBusiness', true)
        } else {
          this.dialogConfirmDel = false
          swal('ผิดพลาด', 'ไม่สาารถลบข้อมูลได้ กรุณาลองใหม่', 'error', {
            button: false,
            timer: 2000
          })
        }
      } catch (error) {
        console.log(error)
      }
      // this.text = 'คุณได้ทำการลบข้อมูลผู้อนุมัติเรียบร้อยแล้ว'
      // this.snackbar = true
    },
    async updateStatusApprove (type) {
      await axios({
        url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/companys/updateStatusReqBusinessByToken`,
        method: 'POST',
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          // approveList: confirmList
          reqBusinessId: this.reqBusinessId,
          status: type === 'อนุมัติ' ? 'approve' : type === 'ไม่อนุมัติ' ? 'reject' : 'cancel',
          role: this.$store.state.user.role[1].permission,
          comment: this.comment
        }
      })
        .then((response) => {
          if (response.data.success === true) {
            swal('สำเร็จ', 'ทำรายการเรียบร้อย', 'success', {
              button: false,
              timer: 2000
            })
            // this.dialog = false
            // this.snackbar = true
            this.page = 1
            this.dialogApproverCompany = false
            this.$router.push('/managebusiness')
            // self.searchFilterData(self.filterData)
          } else {
            swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
              button: false,
              timer: 2000
            })
          }
        })
        .catch(function (thrown) {
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        })
    },
    openDialogManage (item) {
      EventBus.$emit('opendialogmanage', true, item)
    },
    openDialogRoleList (item) {
      console.log('Open', item)
      EventBus.$emit('opendialogRoleListGroup', item)
    },
    gotocreate (title) {
      // this.$router.push('managerolecompany/create')
    },
    checkActionType (item) {
      this.reqBusinessId = item._id
      // if (this.approveRole === 'Super Admin') {
      //   this.approveType = 'ยกเลิก'
      //   this.dialogConfirmDel = true
      // } else {
      //   this.dialogApproverCompany = true
      // }
    },
    gotoEdit (item) {
      this.$router.push({
        name: 'manageBusinesupdateBusiness',
        params: {
          statusedit: true,
          status: item.status,
          id: item.companyId
        }
      })
    },
    gotoPreview (data, title) {
      // this.$router.push('manageposition/update')
      // this.$router.push('managerolecompany/updateGroup/' + data._id)
      this.$router.push({
        name: 'manageBusinesupdateBusiness',
        params: {
          status: data.status,
          id: data.companyId
        }
      })
      // this.$router.push('managebusines/updateBusiness/' + data._id)
    }
  }
}
</script>
<style>
/* table */
.theme--light.v-pagination .v-pagination__item--active {
    background: #2BA197 !important;
    color: #FFFFFF;
}
.v-pagination__item {
    background: transparent;
    border-radius: 4px;
    font-size: 14px;
    height: 30px;
    margin: 0.3rem;
    min-width: 30px;
    padding: 0 5px;
    text-decoration: none;
    transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
    width: auto;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}
.v-pagination__navigation {
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    height: 30px;
    width: 30px;
    margin: 0.3rem 10px;
}
/* end */
.border-table-employee {
  border-radius: 10px;
  border: 1px solid rgb(229, 236, 238);
}

table > tbody > tr > td.fixed:nth-last-child(1),
table > thead > tr > th.fixed:nth-last-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  /* z-index: 9997; */
  background: white;
  /* background: transparent; */
  -webkit-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  -moz-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
}

table > tbody > tr:hover > td.fixed:nth-last-child(1), table > thead > tr:hover > th.fixed:nth-last-child(1) {
  background: #eeeeee;
}

table > thead > tr > th.fixed:nth-last-child(1) {
  /* z-index: 9998; */
  background-color: #F8F9FB;
}
.v-data-table {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 16px;
}
.row-menu-left {
  justify-content: flex-start !important;
}
.row-menu-right {
  justify-content: flex-end !important;
}
.v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: inset 0px 4px 8px -5px rgba(50, 50, 50, 0), inset 0px -4px 8px -5px rgba(50, 50, 50, 0) !important;
}
.padding-left-90 {
  padding-left: 90px !important;
}
.table-name-row {
  display: flex;
  flex-direction: row;
}
.btn-edit-dep {
  background-color: #0370B7 !important;
  color: #fff !important;
}
.btn-del-dep {
  background-color: #da2525 !important;
  color: #fff !important;
}
</style>
